import { ServiceProvidersLicenseUsage } from '../../types'

const report: ServiceProvidersLicenseUsage = {
	name: 'Service provider',
	allocated: 2,
	license_type: 'CRM',
	resellers: [
		{
			name: 'Reseller',
			allocated: 10,
			limit: 10,
			limit_enabled: false
		}
	]
}

export default report
